import React, { FC } from "react";
import { Description, Icon } from "@evergis/ui";
import { ProjectInfoDc } from "@evergis/api";

export const AdditionalProjectInfo: FC<{ project: ProjectInfoDc }> = ({ project }) => (
  <Description>
    <div>
      <Icon kind="layers" />
      {project.layersCount}
    </div>
  </Description>
);
